import {
  fetchMarketWatches,
  deleteMarketWatchInstrument,
  addMarketWatchInstrument,
  setPinnedInstruments,
  getPinnedInstruments,
  searchInstrument,
  addNewMarketwatch,
  fetchOptionChain,
  fetchScreeners,
  saveExistingMarketwatch,
  fetchFutureChain,
  renameMarketwatch
} from "../../services/backendAPI";
import alertify from "alertifyjs";
// import { getFormattedMarketwatches } from "services/utilities/apiDataWithFrontendAddedKeys";
// import { actions } from "react-table";
import { getFormattedMarketwatches } from "../../services/utilities/apiDataWithFrontendAddedKeys";

export const fetchMarketWatchesAction = (forceRefresh = false) => (dispatch) => {
  // Do not auto-refresh at all unless explicitly forced
  if (!forceRefresh) {
    // For debugging only - to be removed in production
    // console.log("Market watch auto-refresh skipped - explicit refresh required");
    return;
  }

  // Skip refresh if document is not visible
  if (document.visibilityState !== 'visible') {
    // console.log("Skipping market watch refresh - document not visible");
    return;
  }

  // Add throttling/debouncing mechanism to prevent excessive calls
  // Check if we've already refreshed recently
  const lastRefreshTime = window._lastMarketWatchRefreshTime || 0;
  const now = Date.now();
  const REFRESH_COOLDOWN = 5000; // 5 seconds minimum between refreshes

  if (now - lastRefreshTime < REFRESH_COOLDOWN) {
    console.log("Skipping market watch refresh - called too frequently");
    return;
  }

  // Store refresh time
  window._lastMarketWatchRefreshTime = now;

  console.log("Fetching market watch data");

  fetchMarketWatches()
    .then(({ data }) => {
      if (data.length > 0) {
        const watchlists = getFormattedMarketwatches(data);
        let instrumentsListTemp = new Map();
        watchlists.map((watchlist)=>{
          let arr = [];
          if(watchlist.instruments.length !== 0){
            watchlist.instruments.map((instrument)=>{
              arr.push(`${instrument.exchange}+${instrument.token}`);
            })
          }
          instrumentsListTemp.set(watchlist.id,arr)
        })
        dispatch({
          type: "SET_INSTRUMENT_LIST",
          payload: instrumentsListTemp
        })
        dispatch({
          type: "SET_WATCHLISTS",
          payload: watchlists,
        });

        dispatch({
          type: "SET_FORMATTED_WATCHLISTS",
          payload: watchlists.map((mw, index) => ({
            ...mw,
            mappedName: mw.name || `MW-${index + 1}`,
          })),
        });
      }
    })
    .catch((err) => dispatch({
      type: 'SET_MARKETWATCH_ERROR_MESSAGE',
      payload: err
    }));
};

export const addNewMarketwatchAction = (name) => async (dispatch) => {
  try {
    const { data, status, message } = await addNewMarketwatch(name);
    if (data.length > 0) {
      const watchlists = getFormattedMarketwatches(data);
      dispatch({
        type: "SET_WATCHLISTS",
        payload: watchlists,
      });
    }
    return { status, message };
  } catch (err) {
    return { status: "error", message: err };
  }
};

export const renameMarketwatchAction = (mw_id, name, watchlistIndex) => async (dispatch) => {
  try {
    const { data, status, message } = await renameMarketwatch(mw_id, name);
    if (status === "success") {
      dispatch({
        type: "RENAME_WATCHLIST",
        payload: { watchlistIndex, name },
      });
    }
    return { status, message };
  } catch (err) {
    return { status: "error", message: err };
  }
};

export const addMarketWatchInstrumentAction = (
  watchlistIndex,
  payload
) => async (dispatch) => {
  try {
    const { data, status, message } = await addMarketWatchInstrument(payload);
    dispatch({
      type: "ADD_NEW_INSTRUMENT",
      payload: { data, watchlistIndex },
    });
    dispatch(setInitialTrackIndexAction());
    return { status, message };
  } catch (err) {
    return { status: "error", message: err };
  }
};

export const deleteMarketWatchInstrumentAction = (
  payload,
  watchlistIndex,
  marketWatches,
  instrument
) => async (dispatch) => {
  const copyMarketWatches = [...marketWatches];
  const { exchange: delExg, token: delToken } = instrument;
  const updatedInstruments = copyMarketWatches[
    watchlistIndex
  ].instruments.filter(
    ({ exchange, token }) => `${exchange}-${token}` !== `${delExg}-${delToken}`
  );

  copyMarketWatches[watchlistIndex].instruments = [...updatedInstruments];

  dispatch({
    type: "DELETE_INSTRUMENT",
    payload: copyMarketWatches,
  });

  dispatch(setInitialTrackIndexAction());
  try {
    const { status, message } = await deleteMarketWatchInstrument(payload);
    return { status, message };
  } catch (err) {
    return { status: "error", message: err };
  }
};

export const getReorderMarketwatchesAction = (
  watchlistIndex,
  currInstruments,
  index
) => (dispatch) => {
  dispatch({
    type: "REORDER_MARKETWATCH",
    payload: { watchlistIndex, currInstruments, index },
  });
};

export const getSortedMarketwatchesAction = (
  watchlistIndex,
  keyName,
  order,
  activeInstrument
) => (dispatch) => {
  dispatch({
    type: "SORT_CURRENT_MARKETWATCH",
    payload: { watchlistIndex, keyName, order, activeInstrument },
  });
};

export const setPinnedInstrumentsAction = (pinsArray) => (dispatch) => {
  const apiPayload = { instruments: pinsArray };
  return setPinnedInstruments(apiPayload)
    .then(({ data }) => {
      dispatch({
        type: "SET_PINNED_INSTRUMENTS",
        payload: data,
      });
      return { status: "success", data: data };
    })
    .catch((err) => {
      dispatch({
        type: 'SET_PINNED_INSTRUMENTS_ERROR_MESSAGE',
        payload: err
      });
      throw err;
    });
};

export const getPinnedInstrumentsAction = () => (dispatch) => {
  getPinnedInstruments()
    .then(({ data }) => {
      let pinsArray = [];
      if (data) {
        if (Array.isArray(data)) {
          pinsArray = data;
        } else if (data.instruments && Array.isArray(data.instruments)) {
          pinsArray = data.instruments;
        } else if (data.data && Array.isArray(data.data.instruments)) {
          pinsArray = data.data.instruments;
        }
      }

      if (pinsArray.length > 0) {
        dispatch({
          type: "SET_PINNED_INSTRUMENTS",
          payload: pinsArray,
        });
      } else {
        dispatch({
          type: "SET_PINNED_INSTRUMENTS",
          payload: [
            {
              display_name: "NIFTY 50",
              exchange: "NSE",
              is_index: true,
              is_tradable: false,
              token: 26000,
              trading_symbol: "NIFTY 50",
            },
            {
              display_name: "Nifty Bank",
              exchange: "NSE",
              is_index: true,
              is_tradable: false,
              token: 26009,
              trading_symbol: "Nifty Bank",
            },
          ],
        });
      }
    })
    .catch((err) =>
      dispatch({
        type: "SET_PINNED_INSTRUMENTS",
        payload: [
          {
            display_name: "NIFTY 50",
            exchange: "NSE",
            is_index: true,
            is_tradable: false,
            token: 26000,
            trading_symbol: "NIFTY 50",
          },
          {
            display_name: "Nifty Bank",
            exchange: "NSE",
            is_index: true,
            is_tradable: false,
            token: 26009,
            trading_symbol: "Nifty Bank",
          },
        ],
      })
    );
};

export const setInitialTrackIndexAction = (data = 0) => (dispatch) => {
  dispatch({
    type: "SET_INITIAL_TRACK_INDEX",
    payload: data,
  });
};

export const setIncrementTrackIndexAction = (watchlistIndex, marketWatches) => (
  dispatch
) => {
  const currInstruments = marketWatches[watchlistIndex].instruments;
  dispatch({
    type: "SET_INCREMENT_TRACK_INDEX",
    payload: currInstruments.length,
  });
};

export const setDecrementTrackIndexAction = (watchlistIndex, marketWatches) => (
  dispatch
) => {
  const currInstruments = marketWatches[watchlistIndex].instruments;
  dispatch({
    type: "SET_DECREMENT_TRACK_INDEX",
    payload: currInstruments.length,
  });
};

export const searchInstrumentAction = (inputQuery, mode) => (dispatch) => {
  searchInstrument(inputQuery)
    .then(({ result }) => {
      if(!mode){
        dispatch({
          type: "SET_SEARCH_RESULT",
          payload: result || [],
        });
      }
      else if(mode==="basket"){
        const filteredResults = result.filter((singleResult) => singleResult.is_tradable === true);
        dispatch({
          type: "SET_BASKET_SEARCH_RESULT",
          payload: filteredResults || [],
        })
      }
      else if(mode==="depth"){
        dispatch({
          type: "SET_DEPTH_SEARCH_RESULT",
          payload: result || [],
        })
      }
    })
    .catch((error) => dispatch({
      type: 'SET_SEARCH_INSTRUMENTS_ERROR_MESSAGE',
      payload: error
    }));
};

export const setActiveDepthPriceAction = (
  token,
  exchange,
  price,
  orderSide,
  trading_symbol
) => (dispatch) => {
  let currInstrumentObjFromDepth = {
    token: token,
    exchange: exchange,
    price: price,
    orderSide: orderSide,
    trading_symbol: trading_symbol,
  };
  dispatch({
    type: "SET_PRICE_FROM_DEPTH",
    payload: currInstrumentObjFromDepth,
  });
};

export const fetchOptionChainAction = (payload) => dispatch => {
  return fetchOptionChain(payload)
    .then(({result}) => {
      dispatch({
        type: 'SET_OPTION_CHAIN_DATA',
        payload: result
      })
      return result;
    })
    .catch((error) => {
      console.error("Error in fetchOptionChainAction:", error);
      // Throw the error so it can be caught by the component
      throw error;
    });
}

export const fetchFutureChainAction = (payload) => dispatch => {
  fetchFutureChain(payload)
    .then(({result}) => {
      dispatch({
        type: 'SET_FUTURE_CHAIN_DATA',
        payload: result
      })
    })
    .catch(({error}) => {
      // alertify.error(error && error.message);
    })
}

const getTopTenInstruments = (data) => {
  if (data.length > 10) {
    return data.slice(0, 10);
  } else {
    return data;
  }
};

const mergeTopTenGainersLosers = (topGainers = [], topLosers = []) => {
  let gainers = topGainers.map((gainer) => {
    return { ...gainer, gainer: true, loser: false };
  });
  let losers = topLosers.map((loser) => {
    return { ...loser, gainer: false, loser: true };
  });

  return gainers.concat(losers);
};

export const fetchTopGainersLosersAction = (endpoint) => (dispatch) => {
  fetchScreeners(endpoint)
    .then(({ data }) => {
      const tenGainers = getTopTenInstruments(data.gainers);
      const tenLosers = getTopTenInstruments(data.losers);
      const mergedArr = mergeTopTenGainersLosers(tenGainers, tenLosers);

      dispatch({
        type: "SET_DAY_GAINERS_LOSERS",
        payload: mergedArr,
      });
    })
    .catch((err) => dispatch({
      type: 'SET_SCREENERS_ERROR_MESSAGE',
      payload: err
    }));
};

export const saveExistingMarketwatchAction = (currentMarketwatch) => async (dispatch) => {
  try {
    const payload = {
      mw_id: currentMarketwatch.id,
      instruments: [...currentMarketwatch.instruments]
    }
    const { data, status, message } = await saveExistingMarketwatch(payload);
    return {status, message};
  } catch (err) {
    return { status: "error", message: err };
  }
}


export const fetchCellOptions = (payload) => dispatch => {
  dispatch({
    type: 'SHOW_HIDE_CELL_OPTIONS',
    payload: payload
  })
};
